// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isEngagementReportDashboardResult = objectOf({
  id: string,
  name: string,
  description: string,
  dashboard_type: nullOrUndefined,
  grid_layout: arrayOf(
    objectOf({
      i: string,
      x: number,
      y: number,
      w: number,
      h: number,
      minW: number,
      minH: number,
      static: boolean,
    })
  ),
  tile_data_queries: arrayOf(
    objectOf({
      id: string,
      sql: string,
    })
  ),
  tiles: arrayOf(
    objectOf({
      id: string,
      company_id: string,
      app_group_id: string,
      developer_id: string,
      dashboard_id: string,
      tile_data_query_id: string,
      x_axis: string,
      group_by: string,
      chart_type: string,
      title: string,
      ignore_columns: arrayOf(nullOrUndefined),
    })
  ),
  variables: arrayOf(nullOrUndefined),
  version: string,
});
